var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96967 10.2803C3.67678 9.98744 3.67678 9.51256 3.96967 9.21967L7.18934 6L3.96967 2.78033C3.67678 2.48744 3.67678 2.01256 3.96967 1.71967C4.26256 1.42678 4.73744 1.42678 5.03033 1.71967L8.78033 5.46967C9.07322 5.76256 9.07322 6.23744 8.78033 6.53033L5.03033 10.2803C4.73744 10.5732 4.26256 10.5732 3.96967 10.2803Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.4aff9b36c7421d4e2f106cf7008d6b8f.svg";
export { ForwardRef as ReactComponent };